<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-afterword element-without-heading full-character-formatting" id="afterword">
<div class="text" id="afterword-text">
<div class="inline-image inline-image-kind-photograph inline-image-size-large inline-image-flow-center inline-image-flow-within-text inline-image-aspect-tall inline-image-without-caption inline-image-begins-section inline-image-before-element-end">
<div class="inline-image-container">
<a class="link-contains-image" href="https://www.aileenerin.com/subscribe" target="_blank">
<img alt="Subscribe to Aileen’s newsletter!" src="images/backmatter---newsletter-1.jpg"/>
</a>
</div>
</div>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center"><a class="content-external-link" href="https://www.aileenerin.com/subscribe" target="_blank">Click here to subscribe!</a></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// want-updates-from-aileen.vue?e0d9cad6